<nz-card class="shadow-sm" style="margin-bottom: 16px;">
    <form nz-form [formGroup]="searchForm" nzLayout="inline">
        
        <nz-form-item>
            <nz-form-label>Name</nz-form-label>
            <nz-form-control>
                <input nz-input formControlName="name" placeholder="Search by name" />
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-label>Category</nz-form-label>
            <nz-form-control style="min-width: 200px;">
                <nz-select formControlName="categoryId" nzPlaceHolder="Select Category" nzAllowClear>
                    @for (c of categories; track c.id) {
                        <nz-option [nzValue]="c.id" [nzLabel]="c.name ?? ''"></nz-option>
                    }
                </nz-select>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-label>Vendor</nz-form-label>
            <nz-form-control style="min-width: 200px;">
                <nz-select formControlName="vendorId" nzPlaceHolder="Select Vendor" nzAllowClear>
                    @for (v of vendors; track v.id) {
                        <nz-option [nzValue]="v.id" [nzLabel]="v.name ?? ''"></nz-option>
                    }
                </nz-select>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-label>Platform</nz-form-label>
            <nz-form-control style="min-width: 150px;">
                <nz-select formControlName="platform" nzPlaceHolder="Select Platform" nzAllowClear>
                    @for (p of platformValues; track p) {
                        <nz-option [nzValue]="p" [nzLabel]="p"></nz-option>
                    }
                </nz-select>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-control>
                <button nz-button nzType="primary" (click)="onSearch()">
                    <span nz-icon nzType="search"></span> Search
                </button>
                <button nz-button (click)="resetForm()" style="margin-left: 8px;">
                    Reset
                </button>
            </nz-form-control>
        </nz-form-item>

    </form>
</nz-card>

<nz-card nzTitle="SDKs" [nzExtra]="extraTemplate" class="shadow-sm">

    <nz-table #basicTable [nzData]="sdks" [nzLoading]="loading" [nzPageSize]="10" [nzBordered]="true" nzSize="middle" [nzScroll]="{ x: '1400px', y:'550px' }">
    <thead>
        <tr>
            <th nzWidth="60px"></th>
            <th nzWidth="50px">ID</th>
            <th nzWidth="150px">Category</th>
            <th nzWidth="130px">Vendor</th>
            <th nzWidth="200px">Name</th>
            <th nzWidth="100px" nzAlign="center">Platform</th>
            <th nzWidth="90px" nzAlign="center">Src</th>
            <th nzWidth="90px" nzAlign="center">Libs</th>
            <th nzWidth="90px" nzAlign="center">Demos</th>
            <th nzWidth="90px" nzAlign="center">Docs</th>
            <th nzWidth="80px" nzAlign="center">Status</th>
            <th nzRight nzAlign="center" nzWidth="160px">Action</th>
        </tr>
    </thead>
    <tbody>
        @for (item of basicTable.data; track item.id) {
        <tr>
            <td [nzShowExpand]="true" [(nzExpand)]="item.expand"></td>
            
            <td>{{ item.id }}</td>
            <td><nz-tag [nzColor]="item.category?.colour">{{ item.category?.name }}</nz-tag></td>
            <td><nz-tag [nzColor]="item.vendor?.colour">{{ item.vendor?.name }}</nz-tag></td>
            
            <td>
                <div style="font-weight: 500;">{{ item.name }}</div>
                <div nz-typography nzEllipsis [nzEllipsisRows]="1" class="text-muted" style="font-size: 11px;">
                    {{ item.description }}
                </div>
            </td>
            
            <td nzAlign="center">
                <nz-space>
                    @for (plat of item.platforms; track plat) {
                        <ng-container *nzSpaceItem>
                            @switch (plat) {
                                @case (platform.Windows) { <span nz-icon nzType="windows" style="color: #0078D7;"></span> }
                                @case (platform.Linux) { <span nz-icon nzType="linux" style="color: #333333;"></span> }
                                @case (platform.Android) { <span nz-icon nzType="android" style="color: #3DDC84;"></span> }
                            }
                        </ng-container>
                    }
                </nz-space>
            </td>

            <td nzAlign="center">
                <nz-badge [nzCount]="getAssetsList(item, SdkAssetTypeEnum.Src).length" [nzStyle]="{ backgroundColor: '#eee', color: '#999', boxShadow: 'none' }"></nz-badge>
            </td>
            <td nzAlign="center">
                <nz-badge [nzCount]="getAssetsList(item, SdkAssetTypeEnum.Lib).length" [nzStyle]="{ backgroundColor: '#eee', color: '#999', boxShadow: 'none' }"></nz-badge>
            </td>
            <td nzAlign="center">
                <nz-badge [nzCount]="getAssetsList(item, SdkAssetTypeEnum.Demo).length" [nzStyle]="{ backgroundColor: '#eee', color: '#999', boxShadow: 'none' }"></nz-badge>
            </td>
            <td nzAlign="center">
                <nz-badge [nzCount]="getAssetsList(item, SdkAssetTypeEnum.Documentation).length" [nzStyle]="{ backgroundColor: '#eee', color: '#999', boxShadow: 'none' }"></nz-badge>
            </td>

            <td nzAlign="center">
                @switch (item.status) {
                    @case (SdkStatusEnum.Active) { <span nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a"></span> }
                    @case (SdkStatusEnum.Disabled) { <span nz-icon nzType="minus-circle" nzTheme="twotone" nzTwotoneColor="#ff4d4f"></span> }
                }
            </td>

            <td nzRight nzAlign="center">
                <button nz-button nzType="default" nzSize="small" (click)="editSdk(item)"
                    class="btn-icon-flex btn-spacer">
                    <span nz-icon [nzType]="authService.hasAccess(PermissionEnum.SdksEdit) ? 'edit' : 'eye'" style="margin-right: 4px;"></span>
					{{ authService.hasAccess(PermissionEnum.SdksEdit) ? 'Edit' : 'View Details' }}
                </button>

                @if (authService.hasAccess(PermissionEnum.SdksEdit)) {
                    <button nz-button nzType="default" nzSize="small" nz-dropdown [nzDropdownMenu]="menu"
                        class="btn-icon-flex">
                        More <span nz-icon nzType="down" style="margin-left: 4px;"></span>
                    </button>

                    <nz-dropdown-menu #menu="nzDropdownMenu">
                        <ul nz-menu>

                            @if (item.status === SdkStatusEnum.Active || item.status === SdkStatusEnum.Disabled) {

                                <li nz-menu-divider></li>
                                <li nz-menu-item nzDanger (click)="delete(item)">
                                    <span nz-icon nzType="delete"></span> Delete
                                </li>

                                @if (item.status === SdkStatusEnum.Active) {
                                <li nz-menu-item nzDanger (click)="disable(item)">
                                    <span nz-icon nzType="stop"></span> Disable
                                </li>
                                }
                                @else if (item.status === SdkStatusEnum.Disabled) {
                                <li nz-menu-item (click)="enable(item)">
                                    <span nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a"></span>
                                    Enable
                                </li>
                                }
                            }
                        </ul>
                    </nz-dropdown-menu>
                }
            </td>
        </tr>

        <tr [nzExpand]="item.expand">
            <div nz-row [nzGutter]="24" style="padding: 16px; background: #fafafa; border-radius: 4px;">
                <div nz-col [nzSpan]="6">
                    <h5 nz-typography nzType="secondary"><span nz-icon nzType="file-zip"></span> Source Files</h5>
                    <ul class="expand-list">
                        @for (file of getAssetsList(item, SdkAssetTypeEnum.Src); track file.id) {
                            <li><a (click)="viewFile(file.driveFileLink)">{{ file.driveFileName }}</a></li>
                        } @empty { <span class="text-muted">No source files</span> }
                    </ul>
                </div>
                <div nz-col [nzSpan]="6">
                    <h5 nz-typography nzType="secondary"><span nz-icon nzType="folder"></span> Libraries</h5>
                    <ul class="expand-list">
                        @for (file of getAssetsList(item, SdkAssetTypeEnum.Lib); track file.id) {
                            <li><a (click)="viewFile(file.driveFileLink)">{{ file.driveFileName }}</a></li>
                        } @empty { <span class="text-muted">No libraries</span> }
                    </ul>
                </div>
                <div nz-col [nzSpan]="6">
                    <h5 nz-typography nzType="secondary"><span nz-icon nzType="play-square"></span> Demos</h5>
                    <ul class="expand-list">
                        @for (file of getAssetsList(item, SdkAssetTypeEnum.Demo); track file.id) {
                            <li><a (click)="viewFile(file.driveFileLink)">{{ file.driveFileName }}</a></li>
                        } @empty { <span class="text-muted">No demos</span> }
                    </ul>
                </div>
                <div nz-col [nzSpan]="6">
                    <h5 nz-typography nzType="secondary"><span nz-icon nzType="book"></span> Documentation</h5>
                    <ul class="expand-list">
                        @for (file of getAssetsList(item, SdkAssetTypeEnum.Documentation); track file.id) {
                            <li><a (click)="viewFile(file.driveFileLink)">{{ file.driveFileName }}</a></li>
                        } @empty { <span class="text-muted">No documentation</span> }
                    </ul>
                </div>
            </div>
        </tr>
        }
    </tbody>
</nz-table>

</nz-card>

<ng-template #extraTemplate>
    @if (authService.hasAccess(PermissionEnum.SdksAdd)) {
        <button nz-button nzType="primary" (click)="addSdk()">
            <span nz-icon nzType="plus"></span> Add SDK
        </button>
    }
</ng-template>

<app-sdk-editor-modal modalId="sdkEditorModal" (saved)="onSave()"></app-sdk-editor-modal>